


















































































































































import { ContractBlockVue } from "fs-pb-vue2/vueModels/contracts-panel/ContractBlockVue";
import { Component } from "vue-property-decorator";

@Component({})
export default class ContractBlock extends ContractBlockVue {
  getContractIconClass(): string {
    if (this.contract.Data.ContractType === 3) return "contract-icon";
    else if (this.contract.Data.ContractType === 4) return "card-icon";
    else return "credit-icon";
  }
}
